import * as React from 'react';

import { RootState } from '../store';

import { Dispatch, Action } from 'redux';
import { UPDATE_FORM, TOGGLE_CHECKOUT } from '../store/login';
import { returntypeof } from '../helper';
import { connect } from 'react-redux';
import { CLOSE_PHOTO, TOGGLE_SELECT_PHOTO, NEXT_PHOTO, Photo, LOAD_COMMS_PHOTOS } from '../store/photos';
import PhotoBrick from './PhotoBrick';

const mapStateToProps = (state: RootState) => ({
    login: state.login,
    photo: state.photo,
    collapsed: state.profile.collapsed,
    num_photos: state.photo.selected.size,
    webshop: state.webshop,
    payment_gateway: state.login.payment_gateway,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    onChange: (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: UPDATE_FORM,
            field: field,
            value: event.currentTarget.value
        })
    },
    onSelect: (id: string) => () => {

        dispatch({type: TOGGLE_SELECT_PHOTO, id});
    },
    toggleCheckoutId: (id: string) => {
        dispatch({type: TOGGLE_CHECKOUT, id})
    },
    toggleCheckout: () => {
        dispatch({type: TOGGLE_CHECKOUT})
    },
    onClose: () => {
        dispatch({type: CLOSE_PHOTO})
    },
    nextPhoto: (forward: boolean) => () => {
        dispatch({type: NEXT_PHOTO, forward})
    },
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

type State = {
    loadFilter: boolean
}

class Gallery extends React.Component<Props, State> {

    constructor(props: Props){
        super(props);
        this.state = {
            loadFilter: false
        }
    }

    onKeyPress = (e: React.KeyboardEvent<any>) => {
        switch(e.key) {
            case "Left":
            case "ArrowLeft":
                this.props.nextPhoto(false)();
            break;
            case "Right":
            case "ArrowRight":
                this.props.nextPhoto(true)();
            break;
            case "Esc":
            case "Escape":
                this.props.onClose();
            break;
        }
    }

    onDownloadClick = (id: string) =>  (e: React.MouseEvent<any>) => {
        if((this.props.payment_gateway != undefined || this.props.login.paypal_gateway != undefined) && !this.props.webshop.orders.has(id) && this.props.login.webshop == true) {
            this.props.toggleCheckoutId(id);
        } else {

            let ticket = encodeURIComponent(this.props.login.ticket || "");
            e.stopPropagation();
            e.preventDefault();

            window.open(`/api/v1/download/original/${id}?sbpportal-ticket=${ticket}`, "_blank");
        }

    }

    // Displays selected
    renderSelected() {
        let ticket = encodeURIComponent(this.props.login.ticket || "");

        if (this.props.photo.opened != undefined) {
            let id = this.props.photo.opened;

            let bricks = this.props.photo.bricks;

            if(this.props.photo.community){
                bricks = this.props.photo.communitybricks;
            }

            let brick = bricks.find(brick => brick.type == "photo" && brick.id == id) as Photo;

            

            if (brick != undefined) {

                let main;

                let is_video;

                let lElem;
                let rElem;

                let index = bricks.findIndex((brick) => brick.type == "photo" && brick.id == this.props.photo.opened)
                let lindex = index -1;
                let rIndex = index + 1;

                if(index == 1){
                    lindex = bricks.length -1;
                }

                if(lindex < 0){
                    lindex = 1;
                }

                if(bricks[lindex].type == "group"){
                    lindex--;
                }

                if(rIndex >= bricks.length){
                    rIndex = 1;
                }
                if(bricks[rIndex].type == "group"){
                    rIndex++;
                }


                let lBrick = bricks[lindex] as Photo;
                let rBrick = bricks[rIndex] as Photo;

                let cost = brick.cost == undefined ? 0 : brick.cost as number;

                let event;
                if(brick.sb_event != null){
                    let value = brick.sb_event.toString();
                    if (value.length > 40){
                        value = value.substring(0, 40);
                        value += "..";
                    }
                    event = " - " + value
                }

                let resolutionText;
                if(brick.exif_pixelXDimension != null && brick.exif_pixelYDimension != null){
                    resolutionText ="Resolution: " + brick.exif_pixelXDimension + "x" + brick.exif_pixelYDimension;
                }

                let size
                if(brick.size != undefined){
                    size = (brick.size as number / 1000000).toFixed(1) + " MB" 
                }
        

                let downloadBtn;

                if(this.props.webshop.orders.has(id)){
                    downloadBtn =  <span><a className="btn-download" onClick={this.onDownloadClick(brick.id)}><img className="download_white" src="/assets/icons/download.png" height="26px" width="auto"></img><img className="download_green" src="/assets/icons/download_green.png" height="26px" width="auto"></img> Download</a></span>;
                }else{
                    let basketText = " Add To Basket";
                    if(this.props.photo.selected.has(id)){
                        basketText = " Added To Basket"
                    }
                    downloadBtn =  <span><a className="btn-add-cart" onClick={this.props.onSelect(brick.id)}><img className="add-cart-white" src="/assets/icons/add-cart.png" height="26px" width="auto" /><img className="add-cart-blue" src="/assets/icons/add-cart-blue.png" height="26px" width="auto" /> {basketText}</a></span>           
                }
                if(this.props.login.webshop == false){
                    downloadBtn =  <span><a className="btn-download" onClick={this.onDownloadClick(brick.id)}><img className="download_white" src="/assets/icons/download.png" height="26px" width="auto"></img><img className="download_green" src="/assets/icons/download_green.png" height="26px" width="auto"></img> Download</a></span>;
                }


                let title;
                let specs;
                let price;

                if (brick.preview_type.some(val => val == "video")) {
                    main = <video preload="auto" controls={true} src={`/api/v1/preview/${this.props.login.rendition_type}/${brick.id}?sbpportal-ticket=${ticket}`} />
                    is_video = true;
                } else {
                        main = <img className="img-responsive mx-auto main-selected-img" src={`/api/v1/preview/${this.props.login.rendition_type}/${brick.id}?sbpportal-ticket=${ticket}`} />
                        title = <h5 className="pb-30">{brick.sb_year}{event}</h5>
                        specs = <p><small>{resolutionText}</small> <small>{size}</small></p>
                        if(this.props.login.webshop){
                            price = <span className="selected-price">${cost.toFixed(2)} </span>
                        }

                    if(lBrick.id == rBrick.id){
                        lElem = null;
                        rElem = null;
                    }
                    else{
                        lElem = <a className="fill-div" onClick={this.props.nextPhoto(false)}><img className="img-responsive text-left" src={`/api/v1/preview/${this.props.login.rendition_type}/${lBrick.id}?sbpportal-ticket=${ticket}`} /><div className="next-prev"><img src="/assets/icons/prev-arrow.png" height="26px" width="auto" ></img></div></a>
                        rElem = <a className="fill-div" onClick={this.props.nextPhoto(true)}><img className="img-responsive text-right" src={`/api/v1/preview/${this.props.login.rendition_type}/${rBrick.id}?sbpportal-ticket=${ticket}`} /><div className="next-prev"><img src="/assets/icons/next-arrow.png" height="26px" width="auto" ></img></div></a>
                   
                    }
                     is_video = false;
                }

                return (
                    <div className="gallery-selected">
                        <div className="cross-arrow">
                            <a className="btn close-btn-select" onClick={this.props.onClose}><img src="/assets/icons/close.svg" width="30px" height="auto"></img></a>
                        </div>

                        <div className="container d-none d-xl-block">
                            <div className="row align-items-center">
                                <div className="col-sm-3 col-lg-3">
                                    {lElem}
                                </div>

                                <div className="col-sm-6 col-lg-6">
                                    <div className="col-12">
                                        {title}
                                    </div>
                                    {main}
                                    <div className="col-12 pt-15">
                                        <div className="float-left">
                                            {specs}
                                        </div>
                                        <div className="float-right">
                                            {price}
                                            {downloadBtn}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-lg-3">
                                    {rElem}
                                </div>
                            </div>
                        </div>

                        <div className="container d-none d-md-block d-lg-block d-xl-none">
                            <div className="row">

                                <div className="col-md-7">
                                    <img className="img-responsive mx-auto main-selected-img" src={`/api/v1/preview/${this.props.login.rendition_type}/${brick.id}?sbpportal-ticket=${ticket}`}/>
                                </div>

                                <div className="col-md-5">
                                    <div className="col-12">
                                        {title}
                                        {specs}
                                        <p className="mt-50">
                                            {price}
                                            {downloadBtn}
                                        </p>
                                    </div>
                                </div>

                                <div className="col-12 mt-70">
                                    <div className="col-sm-3 col-lg-3 float-left">
                                        <a className="fill-div" onClick={this.props.nextPhoto(false)}>
                                            <img className="img-responsive text-right mx-auto select-md-img" src={`/api/v1/preview/${this.props.login.rendition_type}/${lBrick.id}?sbpportal-ticket=${ticket}`}></img>
                                            <div className="next-prev" ><img src="/assets/icons/prev-arrow.png" height="26px" width="auto"></img></div>
                                        </a>
                                    </div>
                                    <div className="col-sm-3 col-lg-3 float-right">
                                        <a className="fill-div" onClick={this.props.nextPhoto(true)}>
                                            <img className="img-responsive text-right mx-auto select-md-img" src={`/api/v1/preview/${this.props.login.rendition_type}/${rBrick.id}?sbpportal-ticket=${ticket}`}></img>
                                            <div className="next-prev" ><img src="/assets/icons/next-arrow.png" height="26px" width="auto"></img></div>
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="container d-xs-block d-sm-block d-md-none d-lg-none d-xl-none p-0 mt-30">
                            <div className="row selected-mobile">

                                <div className="col-12 p-0">
                                    <img className="mx-auto main-selected-img" src={`/api/v1/preview/${this.props.login.rendition_type}/${brick.id}?sbpportal-ticket=${ticket}`}></img> 
                                    <h5 className="h6 pt-15 pb-15 text-center">{brick.sb_year}{event}</h5>
                                </div>

                                <div className="col-12 d-flex justify-content-between p-0">
                                    <div className="float-left mt-10">
`                                       <a onClick={this.props.nextPhoto(false)}>
                                            <img src="/assets/icons/prev-arrow.png" height="26px" width="auto"></img>
                                        </a>
                                    </div>

                                    <div className="">
                                        
                                        {downloadBtn}
                                    </div>

                                    <div className="float-right mt-10">
                                        <a onClick={this.props.nextPhoto(true)}>
                                            <img src="/assets/icons/next-arrow.png" height="26px" width="auto"></img>
                                        </a>
                                    </div>

                                </div>

                                <div className="col-12 p-0">
                                    <div className="float-right">
                                       {price}
                                    </div>
                                    <p className="pt-15"><small>{resolutionText}</small> - <small>{size}</small></p>
                                </div>

                            </div>
                        </div>
                    </div>
                )

            }
        }
    }

    renderBasket() {
        if(this.props.num_photos == 0) {
            return undefined;
        }

        if(this.props.payment_gateway != undefined) {
            return <button onClick={this.props.toggleCheckout} style={{ borderRadius: "50%", borderColor:'black', position: 'fixed', right: "0", padding: ".6rem", margin: "1rem"}} className="btn btn-primary"><i style={{fontSize:'30px',}} className="fas fa-shopping-basket"></i><span style={{position: 'absolute', right: '3px', top: '3px'}} className="badge badge-light"> {this.props.num_photos} </span></button>
    
        }
    }

    renderBasketPopUp() {
        if(this.props.num_photos == 0) {
            return undefined;
        }

        if(this.props.payment_gateway != undefined) {
            return <button onClick={this.toggleCheckout} style={{ borderColor:'black', position: 'fixed', right: "80px", top: '0px',padding: ".6rem", margin: "1rem"}} className="btn btn-primary">Your Basket <i style={{fontSize:'16px',}} className="fas fa-shopping-basket"></i><span style={{position: 'absolute', right: '3px', top: '3px', fontSize: '10px'}} className="badge badge-light"> {this.props.num_photos} </span></button>
    
        }
    }

    toggleCheckout= () => {
        this.props.onClose();
        this.props.toggleCheckout();
    }

    

    public render() {

        let loadImages;
        loadImages =  this.props.photo.bricks.map((brick, i) => <PhotoBrick key={`photo_${i}`}  brick={brick} />)
        if(this.props.photo.community == true){
            loadImages = this.props.photo.communitybricks.map((brick, i) => <PhotoBrick key={`photo_${i}`}  brick={brick} />)
        }

        if(!this.props.photo.loaded) {
            loadImages = <div className="profile" style={{justifyContent: 'center', margin: 'auto', marginTop: '10%', marginBottom: '15%', textAlign: 'center'}}>
            <i className="far fa-user" style={{fontSize: "50px", marginBottom: '5%'}}></i>
            <p className="empty-title h5">No Students Found</p>
            <p className="empty-subtitle">We couldn't find any students associated to your login.  If you think this is in error, please contact your school.</p>
        </div>
        }
        else if(this.props.photo.bricks.length == 0){
            loadImages = <div style={{justifyContent: 'center', margin: 'auto', marginTop: '10%', marginBottom: '15%', textAlign: 'center'}}>
            <i className="far fa-user" style={{fontSize: "50px", marginBottom: '5%'}}></i>
            <p className="empty-title h5">No Photo Found</p>
            <p className="empty-subtitle">No pictures available. Please check with your school if you think it is an error.</p>
        </div>
        }
            
        
        return (
            <div tabIndex={0} onKeyDown={this.onKeyPress} className={this.props.collapsed ? "gallery expanded" : "gallery" }>
                {this.renderSelected()}
                {loadImages}
            </div>
        )

    }

}


export default connect(mapStateToProps, mapDispatchToProps)(Gallery);